import React from 'react';
import { Pages, Dot } from './HBDotsPagination.styles';

export interface IDotsPaginationProps {
    /** Total number of dots to render. */
    pagesNumber?: number;
    /** Color of inactive dots. Defaults to `vars.colors.surface.itemStrong`. */
    color?: string;
    /** Color of the currently active dot. Defaults to `vars.colors.base.accent`. */
    activeColor?: string;
    /** Starting page number used for indexing; dots are numbered from this value. Must match the `activePage` numbering scheme. */
    startingIndex?: number;
    /** The currently active page number, must correspond to `startingIndex`-based numbering. */
    activePage: number;
    /** Callback to change the active page; when omitted, dots are non-interactive. */
    setActivePage?: (page: number) => void;
    /** CSS class applied to the root element. */
    className?: string;
}

const HBDotsPagination = ({
    pagesNumber = 3,
    activeColor,
    color,
    startingIndex = 1,
    activePage,
    setActivePage,
    className
}: IDotsPaginationProps) => {
    if (pagesNumber < 1) {
        return <></>;
    }

    const pages = [];
    while (pages.length < pagesNumber) {
        pages.push(pages.length + startingIndex);
    }

    return (
        <Pages
            className={className}
            data-testid="hb-dots-pagination--container"
        >
            {pages.map(page => (
                <Dot
                    $clickable={!!setActivePage}
                    $isActive={activePage === page}
                    $color={color}
                    $activeColor={activeColor}
                    key={page}
                    onClick={
                        setActivePage ? () => setActivePage(page) : undefined
                    }
                    data-testid="hb-dots-pagination-page--button"
                />
            ))}
        </Pages>
    );
};

export default HBDotsPagination;
